import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header className={`header-nav ${isScrolled ? 'shadow-sm' : ''}`}>
      <div className="container mx-auto px-4 md:px-8 h-full flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center">
          <h1 className="text-xl md:text-2xl font-semibold" style={{ color: 'var(--text-primary)' }}>
            IndoHukum.id
          </h1>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-6">
          <button onClick={() => scrollToSection('profil')} className="nav-link">
            Profil
          </button>
          <button onClick={() => scrollToSection('portfolio')} className="nav-link">
            Portfolio
          </button>
          <button onClick={() => scrollToSection('hukum-pedia')} className="nav-link">
            Hukum Pedia
          </button>
          <button onClick={() => scrollToSection('artikel')} className="nav-link">
            Artikel
          </button>
          <button onClick={() => scrollToSection('pencarian')} className="nav-link">
            Pencarian
          </button>
          <button onClick={() => scrollToSection('kontak')} className="btn-primary">
            Hubungi Kami
          </button>
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden btn-nav"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden absolute top-20 left-0 right-0 bg-white shadow-lg border-t" style={{ borderColor: 'var(--border-light)' }}>
          <nav className="flex flex-col p-4 space-y-3">
            <button onClick={() => scrollToSection('profil')} className="mobile-nav-link">
              Profil
            </button>
            <button onClick={() => scrollToSection('portfolio')} className="mobile-nav-link">
              Portfolio
            </button>
            <button onClick={() => scrollToSection('hukum-pedia')} className="mobile-nav-link">
              Hukum Pedia
            </button>
            <button onClick={() => scrollToSection('artikel')} className="mobile-nav-link">
              Artikel
            </button>
            <button onClick={() => scrollToSection('pencarian')} className="mobile-nav-link">
              Pencarian
            </button>
            <button onClick={() => scrollToSection('kontak')} className="btn-primary w-full mt-2">
              Hubungi Kami
            </button>
          </nav>
        </div>
      )}
    </header>
  );
};
